export default __webpack_public_path__ + "static/media/logo-byn.8eb1d158.png";